import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogTitleRoot: {
      padding: theme.spacing(1),
    },
    dialogContentRoot: {
      padding: theme.spacing(0, 1, 2),
    },
    primaryText: { paddingRight: theme.spacing(0.5) },
    divider: {
      margin: theme.spacing(0.5, 0),
    },
    incentives: {
      marginTop: theme.spacing(),
    },
    miniTableAttribute: {
      fontSize: theme.typography.caption.fontSize,
      flex: 2,
    },
    miniTableRow: {
      display: 'flex',
      alignItems: 'center',
    },
    miniTableValue: {
      flex: 2,
    },
    middlePositionElement: {
      flex: 1.5,
    },
  };
};
